var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-layout flex-column pb-8" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading, background: false }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "flex-level mb-4 mt-1" }, [
        _c("h1", { staticClass: "m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Planification de rendez-vous")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "container-medium m-auto flex" },
          [
            _c(
              "el-collapse",
              {
                staticClass: "collapse-onboarding-mail wp-9 m-auto",
                attrs: { value: _vm.step }
              },
              [
                _c(
                  "el-collapse-item",
                  {
                    attrs: { name: 1, disabled: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                        1/ " +
                                _vm._s(_vm.$l10n.__("Connectez votre compte")) +
                                "\n                        "
                            ),
                            _vm.provider
                              ? _c("span", { staticClass: "fs-3 regular" }, [
                                  _vm._v(_vm._s(_vm.provider.title))
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _vm.hasOnlyEmail
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "onboarding-scheduler-disclaimer mx-auto mb-5"
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "gray-60 semibold mb-2" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$filters.capitalize(
                                          _vm.providerName(
                                            _vm.emailProvider.provider
                                          )
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "mt-0 mb-4" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Vous avez déjà synchronisé un compte pour le module email, afin d'utiliser la fonctionnalité de planification de rendez-vous, vous devez vous connecter avec ce même compte."
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("onboarding-provider", {
                                attrs: {
                                  provider: _vm.emailProvider.provider,
                                  user: _vm.emailProvider.email
                                },
                                on: {
                                  callback: function($event) {
                                    return _vm.validSync(
                                      _vm.emailProvider.provider,
                                      _vm.emailProvider.email
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.needToUpdateScope(_vm.emailProvider.provider)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "br primary-05-bkg mt-2 px-3 onboarding-alert"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "À la prochaine étape vous devrez autoriser l'accès aux permissions d'agenda."
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : _vm.hasOnlySync
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "onboarding-scheduler-disclaimer mx-auto mb-5"
                            },
                            [
                              _c("p", { staticClass: "gray-60 semibold" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$filters.capitalize(
                                        _vm.providerName(
                                          _vm.calendarProvider.provider
                                        )
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Vous avez déjà synchronisé un compte pour le module %s, afin d'utiliser la fonctionnalité de planification de rendez-vous, vous devez vous connecter avec ce même compte.",
                                        _vm.providerName(
                                          _vm.calendarProvider.provider
                                        )
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("onboarding-provider", {
                                attrs: {
                                  provider: _vm.calendarProvider.provider,
                                  user: _vm.calendarProvider.email
                                },
                                on: {
                                  callback: function($event) {
                                    return _vm.validSync(
                                      _vm.calendarProvider.provider,
                                      _vm.calendarProvider.email
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.needToUpdateScope(
                                _vm.calendarProvider.provider
                              )
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "br primary-05-bkg mt-2 px-3 onboarding-alert"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "À la prochaine étape vous devrez autoriser l'accès aux permissions d'agenda."
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : _vm.hasDifferentSync
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "onboarding-scheduler-disclaimer mx-auto mb-5"
                            },
                            [
                              _c("p", { staticClass: "gray-60 semibold" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.providerName(
                                        _vm.calendarProvider.provider
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "card",
                                {
                                  staticClass: "b-1-warning-50 px-3",
                                  attrs: {
                                    background: "warning-05",
                                    padding: 2
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Vous avez synchronisé un compte différent sur le module %(providerName)s. Afin de voir les événements créés depuis le module planification de rendez-vous, nous vous conseillons de modifier le compte connecté sur le module %(providerName)s.",
                                          {
                                            providerName: _vm.providerName(
                                              _vm.calendarProvider.provider
                                            )
                                          }
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("onboarding-provider", {
                                staticClass: "mt-2",
                                attrs: {
                                  provider: _vm.calendarProvider.provider,
                                  user: _vm.calendarProvider.email,
                                  "cta-label": _vm.$t.__("common.actions.edit")
                                },
                                on: {
                                  callback: function($event) {
                                    return _vm.loadPrefs(
                                      _vm.calendarProvider.provider
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "gray-60 mt-7 semibold" },
                                [_vm._v("Module email")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Vous avez déjà synchronisé un compte pour le module email, afin d'utiliser la fonctionnalité de planification de rendez-vous, vous devez vous connecter avec ce même compte."
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("onboarding-provider", {
                                attrs: {
                                  provider: _vm.emailProvider.provider,
                                  user: _vm.emailProvider.email
                                },
                                on: {
                                  callback: function($event) {
                                    return _vm.validSync(
                                      _vm.emailProvider.provider,
                                      _vm.emailProvider.email
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.needToUpdateScope(_vm.emailProvider.provider)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "br primary-05-bkg mt-2 px-3 onboarding-alert"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "À la prochaine étape vous devrez autoriser l'accès aux permissions d'agenda."
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass:
                                "onboarding-scheduler-disclaimer mx-auto mb-5"
                            },
                            [
                              _vm.hasTransfertMode
                                ? _c(
                                    "card",
                                    {
                                      staticClass: "mt-3 b-1-warning-50 px-3",
                                      attrs: {
                                        background: "warning-05",
                                        padding: 2
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Le mode transfert du module email ne vous permet pas d’utiliser la fonctionnalité de planification de rendez-vous. Vous devez utiliser le module email en mode synchronisation."
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _c(
                                    "p",
                                    { staticClass: "semibold gray-60 m-0" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Pour utiliser la fonctionnalité de planification de rendez-vous, vous devez utiliser le module email en mode synchronisation."
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "br primary-05-bkg mt-2 px-3 onboarding-alert"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Une fois le service sélectionné vous serez automatiquement redirigé vers le module email en mode synchronisation"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("email-onboarding-provider", {
                            on: { validProvider: _vm.onValidProvider },
                            scopedSlots: _vm._u([
                              {
                                key: "subtitle",
                                fn: function() {
                                  return [
                                    _c(
                                      "p",
                                      { staticClass: "subtitle fs-3 m-0" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Pour profiter pleinement de la planification de rendez-vous dans Sellsy, sélectionnez le service que vous souhaitez utiliser."
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          })
                        ],
                    _vm._v(" "),
                    _vm.otherProviderError
                      ? [
                          _c(
                            "div",
                            { staticClass: "flex-level jc-center mt-3" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "br warning-05-bkg b-1-warning-50 px-3 onboarding-alert"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Malheureusement la fonctionnalité n’est pas encore disponible sur Sellsy."
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "dashboard" } } },
                            [
                              _c("CompassButton", {
                                staticClass:
                                  "mt-5 mx-auto block onboarding-back",
                                attrs: {
                                  label: _vm.$t.__(
                                    "pages.onboarding.scheduler.OnboardingScheduler.back_to_agenda"
                                  ),
                                  type: "primary"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }